module.exports = __webpack_public_path__ + "static/media/security_bg.3de6f5a8.png";